<script>
import {createWebSocketService} from "@/services/createWebSocketService";

export default {
  name: "WebSocketProvider",
  data() {
    return {
      webSocketService: createWebSocketService()
    }
  },
  provide() {
    return {
      webSocketService: this.webSocketService
    }
  },
  watch: {
    "$route": {
      immediate: true,

      handler(route) {
        const websocketViewersEnabled = route.matched.some(
            routeRecord =>
                routeRecord.meta &&
                routeRecord.meta.websocketViewers
                // [N] à ajouter dans router.js pour surveiller une route avec le systeme de 'viewers'
        )

        if (!websocketViewersEnabled) {
          this.webSocketService.clearResourceKey()
          return
        }

        this.webSocketService.setResourceKey(route.path)
      }
    }
  },
  mounted() {
    this.webSocketService.connect()
  },
  beforeDestroy() {
    this.webSocketService.disconnect()
  },
  render() {
    const defaultSlot = this.$slots.default

    return defaultSlot && defaultSlot[0]
  }
}
</script>